// src/pages/TechnologyTrainingsPage.jsx
import React from "react";
import PageShell from "../components/layout/PageShell";
import TrainingGrid from "../features/training/TrainingGrid";
import ContactSection from "../components/shared/ContactSection";

export default function TechnologyTrainingsPage() {
  return (
    <PageShell>
      <TrainingGrid category="Technologies Training" heading="Technology training programs" />
      <ContactSection />
    </PageShell>
  );
}